import DropdownMenuField from "@/components/ui/DropdownMenuField";
import InputField from "@/components/ui/InputField";
import FontColorField from "@/components/ui/FontColorField";

interface FontRowProps {
  title: string;
  style: string;
  size: string;
  color: string;
  bold: boolean;
  italic: boolean;
  underline: boolean;
  onStyleChange: (value: string) => void;
  onSizeChange: (value: string) => void;
  onColorChange: (value: string) => void;
  onBoldChange: (value: boolean) => void;
  onItalicChange: (value: boolean) => void;
  onUnderlineChange: (value: boolean) => void;
  fontSizes: { label: string; key: string }[];
}

export default function FontRow({
  title,
  style,
  size,
  color,
  bold,
  italic,
  underline,
  onStyleChange,
  onSizeChange,
  onColorChange,
  onBoldChange,
  onItalicChange,
  onUnderlineChange,
  fontSizes,
}: FontRowProps) {
  return (
    <div className="flex items-center gap-4 py-2">
      <div className="w-48 text-sm font-semibold text-gray-700">{title}:</div>
      
      <div className="flex items-center gap-2">
        <div className="w-40">
          <InputField
            maxLength={130}
            title=""
            initialValue={style}
            onChange={onStyleChange}
            text="Warning: Mis-spelling of the font style name can result in errors in content produced."
            
          />
        </div>
      </div>

      <div className="flex items-center gap-2">
        <div className="w-40">
          <DropdownMenuField
            title=""
            itemslist={fontSizes}
            initialValue={size}
            onSelect={onSizeChange}
            text={
                "This is the font size used for full width / height placeholders. We will scale it downwards for smaller sized placeholders."
              }
          />
        </div>
      </div>

      <div className="flex items-center gap-2">
        <div className="w-30">
          <FontColorField
            title=""
            onChange={onColorChange}
            value={color}
          />
        </div>
      </div>

      <div className="flex items-center gap-2">
        <div className="flex gap-1">
          <button
            type="button"
            onClick={() => onBoldChange(!bold)}
            className={`px-2 py-1 text-sm font-bold border rounded cursor-pointer transition-colors duration-200 ${
              bold 
                ? 'bg-as-orange-primary text-white border-as-orange-primary hover:brightness-110' 
                : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50 hover:border-gray-400'
            }`}
            title="Bold"
          >
            <strong>B</strong>
          </button>
          <button
            type="button"
            onClick={() => onItalicChange(!italic)}
            className={`px-2 py-1 text-sm italic border rounded cursor-pointer transition-colors duration-200 ${
              italic 
                ? 'bg-as-orange-primary text-white border-as-orange-primary hover:brightness-110' 
                : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50 hover:border-gray-400'
            }`}
            title="Italic"
          >
            <em>I</em>
          </button>
          <button
            type="button"
            onClick={() => onUnderlineChange(!underline)}
            className={`px-2 py-1 text-sm border rounded cursor-pointer transition-colors duration-200 ${
              underline 
                ? 'bg-as-orange-primary text-white border-as-orange-primary hover:brightness-110' 
                : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50 hover:border-gray-400'
            }`}
            title="Underline"
          >
            <u>U</u>
          </button>
        </div>
      </div>
    </div>
  );
}
